import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.SubmitStep.Acknowledge', {
    byConfirming: 'By confirming this submission, I hereby:',
    certify:
        'Certify to the best of my knowledge that the information provided (specifically including the required information on the Applicant, Directors, Beneficial Owners and Users) is complete and correct;',
    agree: 'Agree to electronic identity verification checks being carried out on the individuals listed;',
    confirm:
        'Confirm that the Users listed are authorized, in accordance with their permission, to act on behalf of the Company indicated.',
});
